import { Chip } from '@mui/material'
import { PrescriptionStatus } from '@services/dtos'
import { PrescriptionStatusLabels } from '@utils/constants'

interface Props {
  status: PrescriptionStatus
}

export const ChipPrescriptionStatus = ({ status }: Props) => (<Chip
  label={PrescriptionStatusLabels[status]}
  style={{ backgroundColor: status === PrescriptionStatus.VALIDATED ? '#459464' : '#f59d3a', color: 'white' }}
  size="small"
/>)
